import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

const categoriesData = [
  { value: 'Sleeve', label: 'Sleeve' },
  { value: 'Poster', label: 'Poster' },
  { value: 'Autograph', label: 'Autograph' },
  { value: 'Lyrics', label: 'Lyrics' },
  { value: 'Event', label: 'Event' },
  { value: 'Video', label: 'Video' },
  { value: 'Art', label: 'Art' },
];

export default function CategoryComponent(props) {
  const router = useRouter();

  let { category: category } = router.query;

  return (
    <div className="filter__group mt-3">
      <label className="filter__label">Category:</label>

      <ul className="filter__checkboxes">
        {categoriesData.map((item, key) => {
          return (
            <li key={key + 'category'}>
              <input
                id={key}
                type="checkbox"
                checked={
                  category && category.includes(item.value) ? true : false
                }
                onChange={(event) => {
                  let modifiedArr = category
                    ? Array.isArray(category)
                      ? [...category]
                      : [category]
                    : [];
                  let indx = modifiedArr.indexOf(item.value);
                  if (indx && indx === -1) {
                    modifiedArr.push(item.value);
                  } else {
                    modifiedArr.splice(indx, 1);
                  }
                  props.updateRoute(['category', modifiedArr], 'addToArr');
                }}
              />
              <label htmlFor={key}>{item.label}</label>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
